"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _apis = require("../../../../@apis");
var _hooks = require("../../../../@hooks");
var _functions = require("../../../../@functions");
var _constants = require("../../../../@constants");
var _TextInput = _interopRequireDefault(require("../../../../@custom/TextInput"));
var _Icon = _interopRequireDefault(require("../../../../@custom/Icon"));
var _SimpleButton = _interopRequireDefault(require("../../../../@custom/SimpleButton"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * @typedef User
 * @type {import("./index.jsx").User}
 */

/**
 * @typedef StepProps
 * @type {import("./index.jsx").StepProps}
 */

/** @param {StepProps} props */
function AccountForm(props) {
  var _errorMsgs$firstName, _errorMsgs$lastName, _errorMsgs$cpf, _errorMsgs$email, _errorMsgs$phoneArea, _errorMsgs$phone;
  var user = props.user,
    goNext = props.goNext,
    updateUser = props.updateUser;
  var _useErrors = (0, _hooks.useErrors)(),
    errorMsgs = _useErrors.errorMsgs,
    addErrorMsg = _useErrors.addErrorMsg,
    removeErrorMsg = _useErrors.removeErrorMsg,
    disabled = _useErrors.disabled;

  /**
   * @param {string} prop
   * @param {any} value
   */
  var validateUpdate = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(prop, value) {
      var cpf, phone;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(prop === 'firstName')) {
              _context.next = 7;
              break;
            }
            if (value) {
              _context.next = 6;
              break;
            }
            addErrorMsg('firstName', 'first-name-missing');
            return _context.abrupt("return", false);
          case 6:
            removeErrorMsg('firstName', 'first-name-missing');
          case 7:
            if (!(prop === 'lastName')) {
              _context.next = 14;
              break;
            }
            if (value) {
              _context.next = 13;
              break;
            }
            addErrorMsg('lastName', 'last-name-missing');
            return _context.abrupt("return", false);
          case 13:
            removeErrorMsg('lastName', 'last-name-missing');
          case 14:
            if (!(prop === 'email')) {
              _context.next = 22;
              break;
            }
            if (_functions.validator.email(value)) {
              _context.next = 21;
              break;
            }
            removeErrorMsg('email', 'email-already-taken');
            addErrorMsg('email', 'invalid-email');
            return _context.abrupt("return", false);
          case 21:
            removeErrorMsg('email', 'invalid-email');

            /*const { data: emailAlreadyTaken } = await appcenterApi.user.exists(value)
            if (emailAlreadyTaken) {
            	addErrorMsg('email', 'email-already-taken')
            	return false
            } else {
            	removeErrorMsg('email', 'email-already-taken')
            }*/
          case 22:
            if (!(prop === 'taxDocument')) {
              _context.next = 36;
              break;
            }
            cpf = value.replace(/[^\d]+/g, '');
            if (cpf) {
              _context.next = 29;
              break;
            }
            addErrorMsg('cpf', 'cpf-missing');
            return _context.abrupt("return", false);
          case 29:
            removeErrorMsg('cpf', 'cpf-missing');
          case 30:
            if (_functions.validator.cpf(cpf)) {
              _context.next = 35;
              break;
            }
            addErrorMsg('cpf', 'invalid-cpf');
            return _context.abrupt("return", false);
          case 35:
            removeErrorMsg('cpf', 'invalid-cpf');
          case 36:
            if (!(prop === 'phoneArea')) {
              _context.next = 49;
              break;
            }
            if (value) {
              _context.next = 42;
              break;
            }
            addErrorMsg('phoneArea', 'phoneArea-missing');
            return _context.abrupt("return", false);
          case 42:
            removeErrorMsg('phoneArea', 'phoneArea-missing');
          case 43:
            if (!(value.length !== 2)) {
              _context.next = 48;
              break;
            }
            addErrorMsg('phoneArea', 'invalid-phoneArea');
            return _context.abrupt("return", false);
          case 48:
            removeErrorMsg('phoneArea', 'invalid-phoneArea');
          case 49:
            if (!(prop === 'phone')) {
              _context.next = 63;
              break;
            }
            phone = value.replace(/[^\d]+/g, '');
            if (phone) {
              _context.next = 56;
              break;
            }
            addErrorMsg('phone', 'phone-missing');
            return _context.abrupt("return", false);
          case 56:
            removeErrorMsg('phone', 'phone-missing');
          case 57:
            if (!(phone.length !== 9)) {
              _context.next = 62;
              break;
            }
            addErrorMsg('phone', 'invalid-phone');
            return _context.abrupt("return", false);
          case 62:
            removeErrorMsg('phone', 'invalid-phone');
          case 63:
            return _context.abrupt("return", true);
          case 64:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function validateUpdate(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  var validateUser = function validateUser() {
    for (var _i = 0, _Object$entries = Object.entries(user); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = (0, _slicedToArray2["default"])(_Object$entries[_i], 2),
        prop = _Object$entries$_i[0],
        value = _Object$entries$_i[1];
      var isValid = validateUpdate(prop, value);
      if (!isValid) return false;
    }
    return true;
  };

  /**
   * @param {string} prop
   * @returns {(evt: React.ChangeEvent<HTMLInputElement>) => Promise<void>}
   */
  var handleUpdateUser = function handleUpdateUser(prop) {
    return /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(evt) {
        var value;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              value = evt.target.value;
              updateUser((0, _defineProperty2["default"])({}, prop, value));
              validateUpdate(prop, value);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x3) {
        return _ref2.apply(this, arguments);
      };
    }();
  };
  var handleConfirmChanges = function handleConfirmChanges() {
    var userIsValid = validateUser();
    if (!canGoNext || !userIsValid) return;
    goNext(_objectSpread({}, user));
  };
  var canGoNext = (0, _react.useMemo)(function () {
    return !disabled && user.firstName && user.lastName && user.taxDocument && user.email && user.phoneArea && user.phone;
  }, [user, disabled]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.FormGroup, {
    row: true
  }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    required: true,
    label: "Primeiro nome",
    onChange: handleUpdateUser('firstName'),
    value: user.firstName
  }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    required: true,
    label: "\xDAltimo nome",
    onChange: handleUpdateUser('lastName'),
    value: user.lastName
  })), ((_errorMsgs$firstName = errorMsgs.firstName) === null || _errorMsgs$firstName === void 0 ? void 0 : _errorMsgs$firstName.length) > 0 && errorMsgs.firstName.map(function (msg) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      key: msg,
      className: "Auth-right-form-error"
    }, "* ", errors[msg]);
  }), ((_errorMsgs$lastName = errorMsgs.lastName) === null || _errorMsgs$lastName === void 0 ? void 0 : _errorMsgs$lastName.length) > 0 && errorMsgs.lastName.map(function (msg) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      key: msg,
      className: "Auth-right-form-error"
    }, "* ", errors[msg]);
  }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    required: true,
    label: "CPF",
    fullWidth: true,
    alwaysShowMask: true,
    mask: _constants.docMasks.cpf,
    onChange: handleUpdateUser('taxDocument'),
    value: user.taxDocument
  }), ((_errorMsgs$cpf = errorMsgs.cpf) === null || _errorMsgs$cpf === void 0 ? void 0 : _errorMsgs$cpf.length) > 0 && errorMsgs.cpf.map(function (msg) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      key: msg,
      className: "Auth-right-form-error"
    }, "* ", errors[msg]);
  }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    required: true,
    label: "Emai",
    placeholder: "exemplo@gmail.com",
    onChange: handleUpdateUser('email'),
    value: user.email
  }), ((_errorMsgs$email = errorMsgs.email) === null || _errorMsgs$email === void 0 ? void 0 : _errorMsgs$email.length) > 0 && errorMsgs.email.map(function (msg) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      key: msg,
      className: "Auth-right-form-error"
    }, "* ", errors[msg]);
  }), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_material.FormGroup, {
    row: true
  }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    required: true,
    label: "C\xF3digo de \xE1rea",
    mask: "99",
    onChange: handleUpdateUser('phoneArea'),
    value: user.phoneArea
  }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    required: true,
    label: "Telefone",
    mask: "99999-9999",
    onChange: handleUpdateUser('phone'),
    value: user.phone
  })), ((_errorMsgs$phoneArea = errorMsgs.phoneArea) === null || _errorMsgs$phoneArea === void 0 ? void 0 : _errorMsgs$phoneArea.length) > 0 && errorMsgs.phoneArea.map(function (msg) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      key: msg,
      className: "Auth-right-form-error"
    }, "* ", errors[msg]);
  }), ((_errorMsgs$phone = errorMsgs.phone) === null || _errorMsgs$phone === void 0 ? void 0 : _errorMsgs$phone.length) > 0 && errorMsgs.phone.map(function (msg) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      key: msg,
      className: "Auth-right-form-error"
    }, "* ", errors[msg]);
  }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: "Data de nascimento",
    type: "date",
    placeholder: "dd/mm/aaaa",
    onChange: handleUpdateUser('birthdate'),
    value: user.birthdate
  }), canGoNext && /*#__PURE__*/_react["default"].createElement(_SimpleButton["default"], {
    fullWidth: true,
    onClick: handleConfirmChanges,
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement("span", null, "Criar conta"), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "faCheckDouble"
  })));
}
AccountForm.propTypes = {
  user: _propTypes["default"].object.isRequired,
  goNext: _propTypes["default"].func.isRequired
};
var _default = AccountForm;
exports["default"] = _default;
var errors = {
  'first-name-missing': 'Primeiro nome é obrigatório',
  'last-name-missing': 'Último nome é obrigatório',
  'invalid-email': 'Email inválido',
  'email-already-taken': 'Email já está em uso',
  // 'birthdate-missing': 'Data de nascimento é obrigatória',
  // 'invalid-birthdate': 'Data de nascimento inválida',
  'phoneArea-missing': 'Código de área é obrigatório',
  'invalid-phoneArea': 'Código de área inválido',
  'phone-missing': 'Número de telefone é obrigatório',
  'invalid-phone': 'Número de telefone inválido',
  'cpf-missing': 'CPF é obrigatório',
  'invalid-cpf': 'CPF inválido'
};